import { IconClose } from "@/assets/icons/geist/IconClose";
import type { PropsWithTestId } from "@/components/podkit/lib/testid";
import { type PropsWithTrackLocation } from "@/hooks/use-segment";
import * as Popover from "@radix-ui/react-popover";
import { type FC, type PropsWithChildren } from "react";

type NudgeProps = {
    open: boolean;
    toggleOpen: () => void;
    ariaLabelPrefix: string;
} & PropsWithTestId &
    PropsWithTrackLocation &
    PropsWithChildren;

export const Nudge: FC<NudgeProps> = ({
    open,
    toggleOpen,
    ariaLabelPrefix,
    children,
    "data-testid": testId,
    "data-track-location": trackLocation,
}) => {
    return (
        <Popover.Root open={open}>
            <Popover.Trigger data-testid={testId} />
            <Popover.Portal>
                <Popover.Content
                    side="top"
                    sticky="always"
                    onCloseAutoFocus={(e) => e.preventDefault()}
                    onOpenAutoFocus={(e) => e.preventDefault()}
                    className="z-10 mb-3 ml-7 hidden max-w-[220px] will-change-[transform,opacity] data-[state=closed]:animate-slideDownAndFadeOut data-[state=open]:animate-slideUpAndFadeIn md:block"
                    data-track-location={trackLocation}
                >
                    <Popover.Close
                        className="text-red fixed right-1 top-3 z-10 inline-flex rounded-[4px] bg-transparent outline-none ring-0 hover:bg-surface-03 focus:ring-0 focus-visible:outline focus-visible:outline-1 focus-visible:outline-offset-0 focus-visible:outline-content-primary active:outline-0 disabled:bg-transparent disabled:text-content-secondary"
                        onClick={toggleOpen}
                        aria-label={`${ariaLabelPrefix} - Dismiss`}
                    >
                        <IconClose size="sm" />
                    </Popover.Close>
                    <div className="flex flex-col items-center gap-2">
                        <div className="flex min-w-[240px] flex-col rounded-2xl border-[0.5px] border-border-base/50 bg-surface-glass p-2 shadow-md backdrop-blur-modal">
                            {children}
                        </div>
                    </div>
                </Popover.Content>
            </Popover.Portal>
        </Popover.Root>
    );
};
